import { CALL_API } from "../context/constValues";
import { getAuthToken } from "../context/auth-context";

const jsonOrError = async (response, fallbackMessage) => {
  let data;
  try {
    data = await response.json();
  } catch {
    throw new Error(`${fallbackMessage} (HTTP ${response.status})`);
  }
  if (!response.ok) {
    throw new Error(data.message || fallbackMessage);
  }
  return data;
};

const pickList = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.result)) return data.result;
  if (Array.isArray(data.anticipos)) return data.anticipos;
  if (Array.isArray(data.anticipo)) return data.anticipo;
  return [];
};

export async function getAllAnticipos() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/anticipos`, {
    headers: { Authorization: "Bearer " + token },
  });
  const data = await jsonOrError(response, "Error al obtener anticipos");
  return pickList(data);
}

export async function getAnticiposDisponibles() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/anticipos/disponibles`, {
    headers: { Authorization: "Bearer " + token },
  });
  const data = await jsonOrError(response, "Error al obtener anticipos disponibles");
  return pickList(data);
}

export async function getAnticiposByOrdenDePago(idordendepago) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/anticiposbyorden/${idordendepago}`, {
    headers: { Authorization: "Bearer " + token },
  });
  const data = await jsonOrError(response, "Error al obtener anticipos de la orden");
  return pickList(data);
}

export async function getAnticiposByCierre(idcierre) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/anticiposbycierre/${idcierre}`, {
    headers: { Authorization: "Bearer " + token },
  });
  const data = await jsonOrError(response, "Error al obtener anticipos del cierre");
  return pickList(data);
}

export async function getAnticiposByFecha({ fechainicio, fechafin }) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/anticipos/bydate`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ fechainicio, fechafin, startDate: fechainicio, endDate: fechafin }),
  });
  const data = await jsonOrError(response, "Error al obtener anticipos por fecha");
  return pickList(data);
}

export async function addAnticipo(objeto) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/anticipos`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(objeto),
  });
  const data = await jsonOrError(response, "Error al insertar anticipo");
  return data.isSaved ?? data.saved ?? data;
}

export async function editAnticipo(objeto) {
  const id = objeto.idanticipo || objeto.idAnticipo || objeto.id;
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/anticipos/${id}`, {
    method: "PUT",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(objeto),
  });
  const data = await jsonOrError(response, "Error al actualizar anticipo");
  return data.isSaved ?? data.saved ?? data;
}

export async function deleteAnticipo(id) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/anticipos/${id}`, {
    method: "DELETE",
    headers: { Authorization: "Bearer " + token },
  });
  const data = await jsonOrError(response, "Error al eliminar anticipo");
  return data.isDeleted ?? data.deleted ?? data;
}
